import { sendEntryToBrowserAddon } from "./communication";
import { useCallback, useEffect } from "react";
import PropTypes from "prop-types";

const Tool = ({ name, callback, children }) => {
  sendEntryToBrowserAddon({ name, callback, type: "tool" });

  const handleMessageFromBrowserAddon = useCallback(
    (msg) => {
      if (
        msg.source == window &&
        msg.data.direction &&
        msg.data.direction == "from-ship"
      ) {
        const m = msg.data.message;
        if (m.command == "call") {
          if (m.tool == name) {
            callback();
          }
        }
      }
    },
    [name, callback]
  );

  useEffect(() => {
    if (window) {
      window.addEventListener("message", handleMessageFromBrowserAddon);
    }
    return () => {
      if (window) {
        window.removeEventListener("message", handleMessageFromBrowserAddon);
      }
    };
  }, [handleMessageFromBrowserAddon]);

  return children || null;
};

Tool.propTypes = {
  name: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired,
};

export default Tool;
